
import React, { FC, useEffect, useMemo, useState } from 'react';

export interface State {
  searchTerm: string;
}

const initialState = {
  searchTerm: '',
};

export const CompanyFinContext = React.createContext<State | any>(initialState);

CompanyFinContext.displayName = 'CompanyFinContext';

export const CompanyFinProvider: FC = (props) => {
  //const param = useParams();
  const [pldata, setPldata] = useState({});
  //console.log('context param', param)
  /* useEffect(() => {
    if (query?.text) {
      updateSearchTerm(query?.text as string);
    } else {
      updateSearchTerm('');
    }
  }); */

  const updatePlData = (PlData) => {
    console.log("SET PL data",PlData);
    setPldata(PlData)
  }
  const value = useMemo(
    () => ({
      pldata,
      updatePlData,
    }),
    [pldata]
  );

  return <CompanyFinContext.Provider value={value} {...props} />;
};

export const useCompanyFin = () => {
  const context = React.useContext(CompanyFinContext);
  if (context === undefined) {
    throw new Error(`useCompanyFin must be used within a CompanyFinProvider`);
  }
  return context;
};